import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { api } from "@/lib/api";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Patients from "@/pages/Patients";
import Professionals from "@/pages/Professionals";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import RequestCare from "@/pages/forms/RequestCare";
import Referral from "@/pages/forms/Referral";
import Consultation from "@/pages/forms/Consultation";
import Apply from "@/pages/forms/Apply";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function AdminRoute({ children }) {
  const [state, setState] = useState("checking");
  useEffect(() => {
    api
      .get("/auth/me")
      .then(() => setState("ok"))
      .catch(() => setState("no"));
  }, []);
  if (state === "checking")
    return (
      <div className="grid min-h-screen place-items-center bg-cream" data-testid="admin-route-loading">
        <p className="font-serif text-xl text-olive/60">Checking access…</p>
      </div>
    );
  return state === "ok" ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09 }}>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/patients-families" element={<Patients />} />
              <Route path="/professionals" element={<Professionals />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/careers/apply" element={<Apply />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-care" element={<RequestCare />} />
              <Route path="/referral" element={<Referral />} />
              <Route path="/consultation" element={<Consultation />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </ReactLenis>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
